import MainSkills from "../../components/Forms/MainSkills";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";

import ListTrainingTable from "./ListTrainingTable";


function ListTraining() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <ListTrainingTable/>
            </BasicCard>
        </>
    )
}
export default ListTraining;